import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconWarning: React.FC<BaseWeatherIconProps> = ({
  onWhite = false,
  className = '',
}) => {
  // Return the JSX expression directly—no extra `{}` around the ternary
  return onWhite ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M52.4122 15.2921C51.4178 13.5694 48.9315 13.5693 47.9369 15.2918L9.35003 82.1244C8.35551 83.8468 9.59862 86 11.5876 86H88.7528C90.7417 86 91.9848 83.8471 90.9905 82.1246L52.4122 15.2921Z"
        className="fill-semantic-red"
      />
      <path
        d="M49 75C47.8954 75 47 74.1046 47 73V69.8651C47 68.7606 47.8954 67.8651 49 67.8651H51.6667C52.7712 67.8651 53.6667 68.7606 53.6667 69.8651V73C53.6667 74.1046 52.7712 75 51.6667 75H49ZM50.0748 64.6086C49.0092 64.6086 48.1308 63.7731 48.0773 62.7089L47.1443 44.1414V41C47.1443 39.8954 48.0398 39 49.1443 39H51.4682C52.5728 39 53.4682 39.8954 53.4682 41V44.1414L52.3128 62.7326C52.2473 63.787 51.373 64.6086 50.3166 64.6086H50.0748Z"
        className="fill-white"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M52.4122 15.2921C51.4178 13.5694 48.9315 13.5693 47.9369 15.2918L9.35003 82.1244C8.35551 83.8468 9.59862 86 11.5876 86H88.7528C90.7417 86 91.9848 83.8471 90.9905 82.1246L52.4122 15.2921Z"
        className="fill-white"
      />
      <path
        d="M49 75C47.8954 75 47 74.1046 47 73V69.8651C47 68.7606 47.8954 67.8651 49 67.8651H51.6667C52.7712 67.8651 53.6667 68.7606 53.6667 69.8651V73C53.6667 74.1046 52.7712 75 51.6667 75H49ZM50.0748 64.6086C49.0092 64.6086 48.1308 63.7731 48.0773 62.7089L47.1443 44.1414V41C47.1443 39.8954 48.0398 39 49.1443 39H51.4682C52.5728 39 53.4682 39.8954 53.4682 41V44.1414L52.3128 62.7326C52.2473 63.787 51.373 64.6086 50.3166 64.6086H50.0748Z"
        className="fill-semantic-red"
      />
    </svg>
  )
}

export default WeatherIconWarning
